"use client";

import GenericConfirmationDialog from "@/shared/ui/GenericConfirmationDialog";
import { useBacklogContext } from "../contexts/BacklogContextProvider";
import { useUserChoices } from "@/state/globalStore";

export default function BacklogConfirmationDialogs() {
  const { confirmOriginDeletion } = useBacklogContext();
  const { countSelectedOrigins } = useUserChoices();

  return (
    <GenericConfirmationDialog
      isOpen={confirmOriginDeletion.isOpen}
      onCloseAction={confirmOriginDeletion.onClose}
      onConfirmAction={confirmOriginDeletion.onConfirm}
      title="Delete source material"
      description={`Are you sure you want to delete ${countSelectedOrigins()} selected source material item(s)? This action cannot be undone.`}
      confirmText="Delete"
    />
  );
}
